import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CssLanding from './pages/CssLanding';
import Configurator from './pages/Configurator';
import Admin from './pages/Admin';
import AdminMode from './pages/AdminMode';
import AdminLogin from './pages/AdminLogin';
import AdminInsights from './pages/AdminInsights';
import AdminBuyerOutreach from './pages/AdminBuyerOutreach';
import AdminAgentOutreach from './pages/AdminAgentOutreach';
import AddProperty from './pages/AddProperty';
import EmailCampaign from './pages/EmailCampaign';
import Unsubscribe from './pages/Unsubscribe';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import Success from './pages/Success';
import FramePreview from './pages/FramePreview';
import Templates from './pages/Templates';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import { FrameProvider } from './contexts/FrameContext';
import QueryRedirect from './pages/QueryRedirect';
import { AuthProvider } from './contexts/AuthContext';
import ContactSheetPage from './pages/ContactSheetPage';
import PropertyTokenPage from './pages/PropertyTokenPage';
import CampaignDashboard from './pages/CampaignDashboard';
import CampaignPropertiesTable from './pages/CampaignPropertiesTable';
import DatabaseSetup from './pages/DatabaseSetup';
import UserLandingPage from './pages/UserLandingPage';
import PetLanding from './pages/PetLanding';

const App: React.FC = () => (
  <AuthProvider>
    <FrameProvider>
      <Router>
        <Routes>
          <Route path="/" element={<CssLanding />} />
          {/* Pet routes - must be before catch-all routes */}
          <Route path="/pet" element={<PetLanding />} />
          <Route path="/pets" element={<PetLanding />} />
          <Route path="/configure" element={<Configurator />} />
          <Route path="/frame" element={<FramePreview />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/success" element={<Success />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminMode />} />
          <Route path="/admin/campaigns" element={<CampaignDashboard />} />
          <Route path="/admin/campaigns/properties" element={<CampaignPropertiesTable />} />
          <Route path="/admin/buyer-outreach" element={<AdminBuyerOutreach />} />
          <Route path="/admin-insights" element={<AdminInsights />} />
          <Route path="/admin-buyer-outreach" element={<AdminBuyerOutreach />} />
          <Route path="/admin-agent-outreach" element={<AdminAgentOutreach />} />
          <Route path="/admin-properties" element={<Admin />} />
          <Route path="/admin/new" element={<AddProperty />} />
          <Route path="/admin/email-campaign" element={<EmailCampaign />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/redirect" element={<QueryRedirect />} />
          <Route path="/contact-sheet" element={<ContactSheetPage />} />
          <Route path="/database-setup" element={<DatabaseSetup />} />
          {/* User landing page route - shows landing with custom images if available */}
          <Route path="/:userId/h" element={<UserLandingPage />} />
          {/* Property token route - must be last to catch any token-like URLs */}
          <Route path="/:token" element={<PropertyTokenPage />} />
        </Routes>
      </Router>
    </FrameProvider>
  </AuthProvider>
);

export default App;